import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { expenseQueryConfig } from '@webapp/modules/expense/query-configs/expense'

export const useMutateResetExpenseRequest = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, void>({
    mutationFn: () => expenseRepository.deleteExpenseRequest(),
    onSuccess: () => {
      queryClient.resetQueries(expenseQueryConfig.drafts().queryKey)
      queryClient.resetQueries(expenseQueryConfig.requestFormData().queryKey)
    },
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
